import React, {Suspense} from 'react';
import {Canvas} from '@react-three/fiber';
import {ACESFilmicToneMapping} from 'three';
import {Environment,} from '@react-three/drei';
import Scene from 'components/webgl/Scene';

const WebGLContainer = () => {
  return (
    <Canvas
      shadows
      dpr={[1, 1]}
      performance={{min: 0.1}}
      gl={{antialias: true, preserveDrawingBuffer: true/*, alpha: true*/}}
      onCreated={({gl}) => {
        gl.toneMapping = ACESFilmicToneMapping;
        // gl.outputEncoding = GammaEncoding; // GammaEncoding removed
      }}
      camera={{position: [0, 1.5, 2], fov: 60}}
      // frameloop={'demand'}
    >
      {/*<Environment preset={'warehouse'}/> // from CDN */}
      <Environment files={'./hdri/empty_warehouse_01_1k.hdr'} background={false} />
      <Scene/>
    </Canvas>
  );

};

export default WebGLContainer;